// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App'
import router from './router'
// import QRCoder from 'qrcodejs2'
import utils from "./utils"


Vue.use(utils);


Vue.config.productionTip = false;
Vue.use(ElementUI);
// Vue.use(QRCoder)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(App),
  router,
  components: { App },
  template: '<App/>'
});





// WEBPACK FOOTER //
// ./src/main.js